(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7353"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7353"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gtFXF", function(module, exports) {

$parcel$export(module.exports, "API_BASE", function () { return $bfefe76c53a30567$export$d43f2f435f160490; });
$parcel$export(module.exports, "TYPESENSE_SERVER", function () { return $bfefe76c53a30567$export$af866aed654b0406; });
const $bfefe76c53a30567$var$IS_DEVELOPMENT = false;
function $bfefe76c53a30567$var$buildTypesenseNode() {
    if ($bfefe76c53a30567$var$IS_DEVELOPMENT) return {
        host: "localhost",
        port: "8108",
        protocol: "http"
    };
    const { hostname: hostname, port: port, protocol: protocol } = window.location;
    return {
        host: hostname,
        port: port || (protocol === "https:" ? "443" : "80"),
        protocol: protocol.replace(":", ""),
        path: "/typesense"
    };
}
const $bfefe76c53a30567$export$4b749d8130c057c8 = $bfefe76c53a30567$var$IS_DEVELOPMENT ? "http://localhost:3001" : window.location.origin;
const $bfefe76c53a30567$export$d43f2f435f160490 = $bfefe76c53a30567$var$IS_DEVELOPMENT ? `${$bfefe76c53a30567$export$4b749d8130c057c8}/api` : "/api";
const $bfefe76c53a30567$export$af866aed654b0406 = {
    apiKey: "xyz",
    nodes: [
        $bfefe76c53a30567$var$buildTypesenseNode()
    ]
};

});


var $gtFXF = parcelRequire("gtFXF");
const $a3eb3fffc17c3156$var$elements = {
    archiveButton: document.querySelector("#archive-button"),
    contextRecordDescription: document.querySelector("#context-record-description"),
    contextRecordIndex: document.querySelector("#context-record-index"),
    contextRecordName: document.querySelector("#context-record-name"),
    contextRecordStatus: document.querySelector("#context-record-status"),
    coverPreview: document.querySelector("#cover-preview"),
    coverUpload: document.querySelector("#cover-upload"),
    deleteButton: document.querySelector("#delete-button"),
    draftButton: document.querySelector("#draft-button"),
    editorContextIndex: document.querySelector("#editor-context-index"),
    editorContextPublished: document.querySelector("#editor-context-published"),
    editorContextSave: document.querySelector("#editor-context-save"),
    editorContextUpdated: document.querySelector("#editor-context-updated"),
    editorTitle: document.querySelector("#editor-title"),
    fieldCategory: document.querySelector("#field-category"),
    fieldCountry: document.querySelector("#field-country"),
    fieldCoverImageUrl: document.querySelector("#field-cover-image-url"),
    fieldDescription: document.querySelector("#field-description"),
    fieldExternalUrl: document.querySelector("#field-external-url"),
    fieldName: document.querySelector("#field-name"),
    fieldRegion: document.querySelector("#field-region"),
    fieldScore: document.querySelector("#field-score"),
    fieldSource: document.querySelector("#field-source"),
    fieldTags: document.querySelector("#field-tags"),
    importButton: document.querySelector("#import-button"),
    importFile: document.querySelector("#import-file"),
    importStatus: document.querySelector("#import-status"),
    listSearch: document.querySelector("#list-search"),
    newRecordButton: document.querySelector("#new-record-button"),
    overviewActivity: document.querySelector("#overview-activity"),
    overviewSummary: document.querySelector("#overview-summary"),
    preview: document.querySelector("#record-preview"),
    publishButton: document.querySelector("#publish-button"),
    recordContextStatusText: document.querySelector("#record-context-status-text"),
    recordContextTitle: document.querySelector("#record-context-title"),
    recordId: document.querySelector("#record-id"),
    recordIndexState: document.querySelector("#record-index-state"),
    recordList: document.querySelector("#record-list"),
    recordPublishedAt: document.querySelector("#record-published-at"),
    recordSaveState: document.querySelector("#record-save-state"),
    recordStatus: document.querySelector("#record-status"),
    recordStatusBadge: document.querySelector("#record-status-badge"),
    recordSummary: document.querySelector("#record-summary"),
    recordUpdatedAt: document.querySelector("#record-updated-at"),
    recordVisibilityText: document.querySelector("#record-visibility-text"),
    saveButton: document.querySelector("#save-button"),
    statusFilter: document.querySelector("#status-filter"),
    toast: document.querySelector("#admin-toast"),
    uploadButton: document.querySelector("#upload-button"),
    workflowSteps: Array.from(document.querySelectorAll("[data-workflow-step]")),
    workspaceSummary: document.querySelector("#workspace-summary")
};
const $a3eb3fffc17c3156$var$editor = new window.Quill("#editor", {
    theme: "snow",
    modules: {
        toolbar: [
            [
                {
                    header: [
                        2,
                        3,
                        false
                    ]
                }
            ],
            [
                "bold",
                "italic",
                "underline",
                "blockquote"
            ],
            [
                {
                    list: "ordered"
                },
                {
                    list: "bullet"
                }
            ],
            [
                "link"
            ],
            [
                "clean"
            ]
        ]
    }
});
const $a3eb3fffc17c3156$var$state = {
    activeId: null,
    activeRecord: null,
    isDirty: false,
    lastPersistedSignature: "",
    listQuery: "",
    listStatus: "all",
    requestedId: new URLSearchParams(window.location.search).get("recordId"),
    summary: null,
    toastTimer: null
};
function $a3eb3fffc17c3156$var$statusClassName(status) {
    return `status-badge status-badge--${status || "draft"}`;
}
function $a3eb3fffc17c3156$var$titleizeStatus(status) {
    const value = String(status || "draft").trim();
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $a3eb3fffc17c3156$var$formatDate(timestamp) {
    if (!timestamp) return "Not yet";
    return new Date(timestamp * 1000).toISOString().slice(0, 16).replace("T", " ");
}
function $a3eb3fffc17c3156$var$splitTags(input) {
    return String(input || "").split(/[,\n|]/).map((item)=>item.trim()).filter(Boolean);
}
function $a3eb3fffc17c3156$var$normalizeHtml(input) {
    const value = String(input || "").replace(/\s+/g, " ").trim();
    return value === "<p><br></p>" ? "" : value;
}
function $a3eb3fffc17c3156$var$payloadSignature(payload) {
    return JSON.stringify({
        category: String(payload.category || "").trim(),
        contentHtml: $a3eb3fffc17c3156$var$normalizeHtml(payload.contentHtml),
        country: String(payload.country || "").trim(),
        coverImageUrl: String(payload.coverImageUrl || "").trim(),
        descriptionPlain: String(payload.descriptionPlain || "").trim(),
        externalUrl: String(payload.externalUrl || "").trim(),
        name: String(payload.name || "").trim(),
        region: String(payload.region || "").trim(),
        score: Number(payload.score) || 0,
        source: String(payload.source || "").trim(),
        status: String(payload.status || "draft").trim(),
        tags: $a3eb3fffc17c3156$var$splitTags(payload.tags || []).join("|")
    });
}
function $a3eb3fffc17c3156$var$recordToPayload(record) {
    return {
        name: record.name,
        category: record.category,
        country: record.country,
        region: record.region,
        source: record.source,
        score: record.score,
        tags: record.tags || [],
        descriptionPlain: record.descriptionPlain || "",
        contentHtml: record.contentHtml || "",
        coverImageUrl: record.coverImageUrl || "",
        externalUrl: record.externalUrl || "",
        status: record.status || "draft"
    };
}
function $a3eb3fffc17c3156$var$createSummaryMarkup(summary) {
    return `
    <div class="summary-chip"><span>All</span><strong>${summary.all}</strong></div>
    <div class="summary-chip"><span>Draft</span><strong>${summary.draft}</strong></div>
    <div class="summary-chip"><span>Published</span><strong>${summary.published}</strong></div>
    <div class="summary-chip"><span>Archived</span><strong>${summary.archived}</strong></div>
  `;
}
function $a3eb3fffc17c3156$var$setText(element, value) {
    if (element) element.textContent = value;
}
function $a3eb3fffc17c3156$var$setStatusBadge(element, status) {
    if (!element) return;
    element.className = $a3eb3fffc17c3156$var$statusClassName(status);
    element.textContent = status;
}
function $a3eb3fffc17c3156$var$setContextChip(element, text, tone = "muted") {
    if (!element) return;
    element.className = `context-chip context-chip--${tone}`;
    element.textContent = text;
}
function $a3eb3fffc17c3156$var$summarizeRecord(payload) {
    const summary = payload.descriptionPlain || "Start a new draft or select an existing record to continue editing.";
    return summary.length > 120 ? `${summary.slice(0, 117)}...` : summary;
}
function $a3eb3fffc17c3156$var$currentVisibility(status, isDirty) {
    if (status !== "published") return "Hidden until published";
    return isDirty ? "Published snapshot live, edits pending sync" : "Visible in search preview";
}
function $a3eb3fffc17c3156$var$currentIndexTone(status, isDirty) {
    if (status !== "published") return {
        text: "Index hidden",
        tone: "muted"
    };
    if (isDirty) return {
        text: "Index out of sync",
        tone: "warning"
    };
    return {
        text: "Live in search",
        tone: "success"
    };
}
function $a3eb3fffc17c3156$var$currentSaveTone(isDirty) {
    return isDirty ? {
        text: "Unsaved changes",
        tone: "warning"
    } : {
        text: "No pending changes",
        tone: "success"
    };
}
function $a3eb3fffc17c3156$var$updateWorkflow(status, isDirty) {
    const mode = status === "published" ? "published" : "draft";
    $a3eb3fffc17c3156$var$elements.workflowSteps.forEach((step)=>{
        step.classList.remove("is-active", "is-complete");
    });
    const createStep = $a3eb3fffc17c3156$var$elements.workflowSteps.find((step)=>step.dataset.workflowStep === "create");
    const refineStep = $a3eb3fffc17c3156$var$elements.workflowSteps.find((step)=>step.dataset.workflowStep === "refine");
    const publishStep = $a3eb3fffc17c3156$var$elements.workflowSteps.find((step)=>step.dataset.workflowStep === "publish");
    const previewStep = $a3eb3fffc17c3156$var$elements.workflowSteps.find((step)=>step.dataset.workflowStep === "preview");
    createStep?.classList.add("is-complete");
    if (mode === "draft") refineStep?.classList.add("is-active");
    else {
        refineStep?.classList.add("is-complete");
        publishStep?.classList.add("is-complete");
        previewStep?.classList.add(isDirty ? "is-active" : "is-complete");
    }
    if (mode === "draft" && !isDirty) publishStep?.classList.add("is-active");
}
function $a3eb3fffc17c3156$var$collectFormPayload() {
    return {
        name: $a3eb3fffc17c3156$var$elements.fieldName.value.trim(),
        category: $a3eb3fffc17c3156$var$elements.fieldCategory.value.trim(),
        country: $a3eb3fffc17c3156$var$elements.fieldCountry.value.trim(),
        region: $a3eb3fffc17c3156$var$elements.fieldRegion.value.trim(),
        source: $a3eb3fffc17c3156$var$elements.fieldSource.value.trim(),
        score: Number($a3eb3fffc17c3156$var$elements.fieldScore.value) || 0,
        tags: $a3eb3fffc17c3156$var$splitTags($a3eb3fffc17c3156$var$elements.fieldTags.value),
        descriptionPlain: $a3eb3fffc17c3156$var$elements.fieldDescription.value.trim(),
        contentHtml: $a3eb3fffc17c3156$var$editor.root.innerHTML,
        coverImageUrl: $a3eb3fffc17c3156$var$elements.fieldCoverImageUrl.value.trim(),
        externalUrl: $a3eb3fffc17c3156$var$elements.fieldExternalUrl.value.trim(),
        status: $a3eb3fffc17c3156$var$elements.recordStatus.value
    };
}
async function $a3eb3fffc17c3156$var$request(path, options = {}) {
    const response = await fetch(`${(0, $gtFXF.API_BASE)}${path}`, {
        headers: {
            "Content-Type": "application/json",
            ...options.headers || {}
        },
        ...options
    });
    const isJson = response.headers.get("content-type")?.includes("application/json");
    const data = isJson ? await response.json() : await response.text();
    if (!response.ok) throw new Error(data.error || data || "Request failed");
    return data;
}
function $a3eb3fffc17c3156$var$showToast(message) {
    clearTimeout($a3eb3fffc17c3156$var$state.toastTimer);
    $a3eb3fffc17c3156$var$elements.toast.hidden = false;
    $a3eb3fffc17c3156$var$elements.toast.textContent = message;
    $a3eb3fffc17c3156$var$state.toastTimer = window.setTimeout(()=>{
        $a3eb3fffc17c3156$var$elements.toast.hidden = true;
    }, 2800);
}
function $a3eb3fffc17c3156$var$emitRecordsChanged(reason, recordId = null) {
    window.dispatchEvent(new CustomEvent("records:changed", {
        detail: {
            reason: reason,
            recordId: recordId
        }
    }));
}
function $a3eb3fffc17c3156$var$setStatus(status) {
    $a3eb3fffc17c3156$var$elements.recordStatus.value = status;
    $a3eb3fffc17c3156$var$setStatusBadge($a3eb3fffc17c3156$var$elements.recordStatusBadge, status);
    $a3eb3fffc17c3156$var$setStatusBadge($a3eb3fffc17c3156$var$elements.contextRecordStatus, status);
}
function $a3eb3fffc17c3156$var$syncUrl(recordId = null) {
    const url = new URL(window.location.href);
    if (recordId) {
        url.searchParams.set("recordId", recordId);
        if (!url.hash) url.hash = "records";
    } else url.searchParams.delete("recordId");
    window.history.replaceState({}, "", url);
}
function $a3eb3fffc17c3156$var$renderSummary(summary) {
    const markup = $a3eb3fffc17c3156$var$createSummaryMarkup(summary);
    $a3eb3fffc17c3156$var$state.summary = summary;
    [
        $a3eb3fffc17c3156$var$elements.recordSummary,
        $a3eb3fffc17c3156$var$elements.overviewSummary,
        $a3eb3fffc17c3156$var$elements.workspaceSummary
    ].forEach((element)=>{
        if (element) element.innerHTML = markup;
    });
}
function $a3eb3fffc17c3156$var$renderActivity(items) {
    if (!$a3eb3fffc17c3156$var$elements.overviewActivity) return;
    if (!items.length) {
        $a3eb3fffc17c3156$var$elements.overviewActivity.innerHTML = `<div class="activity-item"><small>No recent activity yet.</small></div>`;
        return;
    }
    $a3eb3fffc17c3156$var$elements.overviewActivity.innerHTML = items.slice(0, 4).map((record)=>`
        <button class="activity-item" type="button" data-record-item="${record.id}">
          <div class="activity-item__row">
            <strong>${record.name}</strong>
            <span class="${$a3eb3fffc17c3156$var$statusClassName(record.status)}">${record.status}</span>
          </div>
          <small>${record.category} \xb7 ${record.country} \xb7 Updated ${$a3eb3fffc17c3156$var$formatDate(record.updatedAt)}</small>
        </button>
      `).join("");
}
function $a3eb3fffc17c3156$var$updateContextPanels() {
    const payload = $a3eb3fffc17c3156$var$collectFormPayload();
    const status = payload.status || "draft";
    const displayName = payload.name || "New Record";
    const lastSaved = $a3eb3fffc17c3156$var$formatDate($a3eb3fffc17c3156$var$state.activeRecord?.updatedAt);
    const publishedAt = $a3eb3fffc17c3156$var$formatDate($a3eb3fffc17c3156$var$state.activeRecord?.publishedAt);
    const visibility = $a3eb3fffc17c3156$var$currentVisibility(status, $a3eb3fffc17c3156$var$state.isDirty);
    const saveState = $a3eb3fffc17c3156$var$currentSaveTone($a3eb3fffc17c3156$var$state.isDirty);
    const indexState = $a3eb3fffc17c3156$var$currentIndexTone(status, $a3eb3fffc17c3156$var$state.isDirty);
    $a3eb3fffc17c3156$var$setText($a3eb3fffc17c3156$var$elements.contextRecordName, displayName);
    $a3eb3fffc17c3156$var$setText($a3eb3fffc17c3156$var$elements.contextRecordDescription, $a3eb3fffc17c3156$var$summarizeRecord(payload));
    $a3eb3fffc17c3156$var$setText($a3eb3fffc17c3156$var$elements.recordContextTitle, displayName);
    $a3eb3fffc17c3156$var$setText($a3eb3fffc17c3156$var$elements.recordContextStatusText, $a3eb3fffc17c3156$var$titleizeStatus(status));
    $a3eb3fffc17c3156$var$setText($a3eb3fffc17c3156$var$elements.recordUpdatedAt, lastSaved);
    $a3eb3fffc17c3156$var$setText($a3eb3fffc17c3156$var$elements.recordVisibilityText, visibility);
    $a3eb3fffc17c3156$var$setContextChip($a3eb3fffc17c3156$var$elements.contextRecordIndex, indexState.text, indexState.tone);
    $a3eb3fffc17c3156$var$setContextChip($a3eb3fffc17c3156$var$elements.recordSaveState, saveState.text, saveState.tone);
    $a3eb3fffc17c3156$var$setContextChip($a3eb3fffc17c3156$var$elements.recordIndexState, indexState.text, indexState.tone);
    $a3eb3fffc17c3156$var$setContextChip($a3eb3fffc17c3156$var$elements.editorContextSave, saveState.text, saveState.tone);
    $a3eb3fffc17c3156$var$setContextChip($a3eb3fffc17c3156$var$elements.editorContextIndex, indexState.text, indexState.tone);
    $a3eb3fffc17c3156$var$setContextChip($a3eb3fffc17c3156$var$elements.editorContextUpdated, `Last saved: ${lastSaved}`, "muted");
    $a3eb3fffc17c3156$var$setContextChip($a3eb3fffc17c3156$var$elements.editorContextPublished, `Published: ${publishedAt}`, "muted");
    $a3eb3fffc17c3156$var$setContextChip($a3eb3fffc17c3156$var$elements.recordPublishedAt, `Published: ${publishedAt}`, "muted");
    $a3eb3fffc17c3156$var$updateWorkflow(status, $a3eb3fffc17c3156$var$state.isDirty);
}
function $a3eb3fffc17c3156$var$updateDirtyState() {
    const nextSignature = $a3eb3fffc17c3156$var$payloadSignature($a3eb3fffc17c3156$var$collectFormPayload());
    $a3eb3fffc17c3156$var$state.isDirty = nextSignature !== $a3eb3fffc17c3156$var$state.lastPersistedSignature;
    $a3eb3fffc17c3156$var$updateContextPanels();
}
function $a3eb3fffc17c3156$var$renderPreview() {
    const payload = $a3eb3fffc17c3156$var$collectFormPayload();
    const tags = payload.tags.map((tag)=>`<span>${tag}</span>`).join("");
    const coverStyle = payload.coverImageUrl ? `style="background-image: url('${payload.coverImageUrl}')"` : "";
    $a3eb3fffc17c3156$var$elements.preview.innerHTML = `
    <article class="record-card">
      <div class="record-card__cover ${payload.coverImageUrl ? "has-image" : ""}" ${coverStyle}>
        <div class="record-card__cover-badge">${payload.category || "category"}</div>
      </div>
      <div class="record-card__body">
        <h2 class="record-card__title">${payload.name || "Untitled record"}</h2>
        <div class="record-card__meta">
          <span>${payload.country || "Country"}</span>
          <span>${payload.region || "Region"}</span>
        </div>
        <p class="record-card__description">${payload.descriptionPlain || "Summary preview will appear here."}</p>
        <div class="record-card__tags">${tags}</div>
        <div class="record-card__footer">
          <span>Source: ${payload.source || "manual_entry"}</span>
          <span>Status: ${payload.status}</span>
          <span>Score: ${payload.score}</span>
        </div>
      </div>
    </article>
  `;
    $a3eb3fffc17c3156$var$elements.coverPreview.style.backgroundImage = payload.coverImageUrl ? `url('${payload.coverImageUrl}')` : "";
    $a3eb3fffc17c3156$var$updateDirtyState();
}
function $a3eb3fffc17c3156$var$fillForm(record) {
    $a3eb3fffc17c3156$var$state.activeId = record.id;
    $a3eb3fffc17c3156$var$state.activeRecord = record;
    $a3eb3fffc17c3156$var$state.requestedId = record.id;
    $a3eb3fffc17c3156$var$elements.recordId.value = record.id;
    $a3eb3fffc17c3156$var$elements.editorTitle.textContent = record.name;
    $a3eb3fffc17c3156$var$elements.fieldName.value = record.name;
    $a3eb3fffc17c3156$var$elements.fieldCategory.value = record.category;
    $a3eb3fffc17c3156$var$elements.fieldCountry.value = record.country;
    $a3eb3fffc17c3156$var$elements.fieldRegion.value = record.region;
    $a3eb3fffc17c3156$var$elements.fieldSource.value = record.source;
    $a3eb3fffc17c3156$var$elements.fieldScore.value = record.score;
    $a3eb3fffc17c3156$var$elements.fieldTags.value = (record.tags || []).join(", ");
    $a3eb3fffc17c3156$var$elements.fieldDescription.value = record.descriptionPlain || "";
    $a3eb3fffc17c3156$var$elements.fieldCoverImageUrl.value = record.coverImageUrl || "";
    $a3eb3fffc17c3156$var$elements.fieldExternalUrl.value = record.externalUrl || "";
    $a3eb3fffc17c3156$var$editor.root.innerHTML = record.contentHtml || "";
    $a3eb3fffc17c3156$var$setStatus(record.status || "draft");
    $a3eb3fffc17c3156$var$syncUrl(record.id);
    $a3eb3fffc17c3156$var$state.lastPersistedSignature = $a3eb3fffc17c3156$var$payloadSignature($a3eb3fffc17c3156$var$recordToPayload(record));
    $a3eb3fffc17c3156$var$state.isDirty = false;
    $a3eb3fffc17c3156$var$renderPreview();
    $a3eb3fffc17c3156$var$updateActionState();
}
function $a3eb3fffc17c3156$var$resetForm() {
    $a3eb3fffc17c3156$var$state.activeId = null;
    $a3eb3fffc17c3156$var$state.activeRecord = null;
    $a3eb3fffc17c3156$var$state.requestedId = null;
    $a3eb3fffc17c3156$var$elements.recordId.value = "";
    $a3eb3fffc17c3156$var$elements.editorTitle.textContent = "New Record";
    $a3eb3fffc17c3156$var$elements.fieldName.value = "";
    $a3eb3fffc17c3156$var$elements.fieldCategory.value = "";
    $a3eb3fffc17c3156$var$elements.fieldCountry.value = "";
    $a3eb3fffc17c3156$var$elements.fieldRegion.value = "";
    $a3eb3fffc17c3156$var$elements.fieldSource.value = "manual_entry";
    $a3eb3fffc17c3156$var$elements.fieldScore.value = "50";
    $a3eb3fffc17c3156$var$elements.fieldTags.value = "";
    $a3eb3fffc17c3156$var$elements.fieldDescription.value = "";
    $a3eb3fffc17c3156$var$elements.fieldCoverImageUrl.value = "";
    $a3eb3fffc17c3156$var$elements.fieldExternalUrl.value = "";
    $a3eb3fffc17c3156$var$editor.root.innerHTML = "";
    $a3eb3fffc17c3156$var$setStatus("draft");
    $a3eb3fffc17c3156$var$syncUrl(null);
    $a3eb3fffc17c3156$var$state.lastPersistedSignature = $a3eb3fffc17c3156$var$payloadSignature($a3eb3fffc17c3156$var$collectFormPayload());
    $a3eb3fffc17c3156$var$state.isDirty = false;
    $a3eb3fffc17c3156$var$renderPreview();
    $a3eb3fffc17c3156$var$updateActionState();
}
function $a3eb3fffc17c3156$var$renderRecordList(items) {
    if (!items.length) {
        $a3eb3fffc17c3156$var$elements.recordList.innerHTML = `<div class="record-list__item">No records match the current filter.</div>`;
        return;
    }
    $a3eb3fffc17c3156$var$elements.recordList.innerHTML = items.map((record)=>`
        <button class="record-list__item ${record.id === $a3eb3fffc17c3156$var$state.activeId ? "is-active" : ""}" type="button" data-record-item="${record.id}">
          <div class="record-list__item-header">
            <div class="record-list__title">${record.name}</div>
            <span class="record-list__score">Score ${record.score}</span>
          </div>
          <div class="record-list__meta">
            <span>${record.category}</span>
            <span>${record.country}</span>
            <span>${record.region}</span>
          </div>
          <div class="record-list__meta">
            <span class="${$a3eb3fffc17c3156$var$statusClassName(record.status)}">${record.status}</span>
            <span>${record.source}</span>
            <span>Updated ${$a3eb3fffc17c3156$var$formatDate(record.updatedAt)}</span>
          </div>
        </button>
      `).join("");
}
async function $a3eb3fffc17c3156$var$loadRecord(id) {
    const record = await $a3eb3fffc17c3156$var$request(`/records/${id}`);
    $a3eb3fffc17c3156$var$fillForm(record);
}
async function $a3eb3fffc17c3156$var$loadRecords() {
    const result = await $a3eb3fffc17c3156$var$request(`/records?status=${encodeURIComponent($a3eb3fffc17c3156$var$state.listStatus)}&q=${encodeURIComponent($a3eb3fffc17c3156$var$state.listQuery)}&limit=100`);
    $a3eb3fffc17c3156$var$renderSummary(result.summary);
    $a3eb3fffc17c3156$var$renderActivity(result.items);
    $a3eb3fffc17c3156$var$renderRecordList(result.items);
    if ($a3eb3fffc17c3156$var$state.activeId) {
        const stillExists = result.items.find((item)=>item.id === $a3eb3fffc17c3156$var$state.activeId);
        if (!stillExists) $a3eb3fffc17c3156$var$resetForm();
        return;
    }
    if ($a3eb3fffc17c3156$var$state.requestedId) {
        const requestedRecord = result.items.find((item)=>item.id === $a3eb3fffc17c3156$var$state.requestedId);
        if (requestedRecord) {
            await $a3eb3fffc17c3156$var$loadRecord(requestedRecord.id);
            return;
        }
    }
    if (result.items[0]) await $a3eb3fffc17c3156$var$loadRecord(result.items[0].id);
}
async function $a3eb3fffc17c3156$var$saveRecord(nextStatus = null) {
    const payload = $a3eb3fffc17c3156$var$collectFormPayload();
    payload.status = nextStatus || payload.status;
    const method = $a3eb3fffc17c3156$var$state.activeId ? "PUT" : "POST";
    const path = $a3eb3fffc17c3156$var$state.activeId ? `/records/${$a3eb3fffc17c3156$var$state.activeId}` : "/records";
    const record = await $a3eb3fffc17c3156$var$request(path, {
        method: method,
        body: JSON.stringify(payload)
    });
    $a3eb3fffc17c3156$var$fillForm(record);
    await $a3eb3fffc17c3156$var$loadRecords();
    $a3eb3fffc17c3156$var$emitRecordsChanged(nextStatus || "saved", record.id);
    $a3eb3fffc17c3156$var$showToast(nextStatus ? `Record moved to ${nextStatus}` : "Record saved");
}
async function $a3eb3fffc17c3156$var$deleteActiveRecord() {
    if (!$a3eb3fffc17c3156$var$state.activeId) return;
    if (!window.confirm("Delete this record permanently?")) return;
    await $a3eb3fffc17c3156$var$request(`/records/${$a3eb3fffc17c3156$var$state.activeId}`, {
        method: "DELETE"
    });
    $a3eb3fffc17c3156$var$resetForm();
    await $a3eb3fffc17c3156$var$loadRecords();
    $a3eb3fffc17c3156$var$emitRecordsChanged("deleted");
    $a3eb3fffc17c3156$var$showToast("Record deleted");
}
async function $a3eb3fffc17c3156$var$uploadCover() {
    const file = $a3eb3fffc17c3156$var$elements.coverUpload.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetch(`${(0, $gtFXF.API_BASE)}/uploads`, {
        method: "POST",
        body: formData
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Upload failed");
    $a3eb3fffc17c3156$var$elements.fieldCoverImageUrl.value = data.url;
    $a3eb3fffc17c3156$var$renderPreview();
    $a3eb3fffc17c3156$var$showToast("Cover uploaded");
}
async function $a3eb3fffc17c3156$var$importBatch() {
    const file = $a3eb3fffc17c3156$var$elements.importFile.files[0];
    if (!file) throw new Error("Choose a JSON or CSV file first");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("status", $a3eb3fffc17c3156$var$elements.importStatus.value);
    const response = await fetch(`${(0, $gtFXF.API_BASE)}/import`, {
        method: "POST",
        body: formData
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Import failed");
    await $a3eb3fffc17c3156$var$loadRecords();
    $a3eb3fffc17c3156$var$emitRecordsChanged("imported");
    $a3eb3fffc17c3156$var$showToast(`Imported ${data.imported} records`);
}
function $a3eb3fffc17c3156$var$updateActionState() {
    const hasRecord = Boolean($a3eb3fffc17c3156$var$state.activeId);
    $a3eb3fffc17c3156$var$elements.deleteButton.disabled = !hasRecord;
}
function $a3eb3fffc17c3156$var$handleRecordSelection(event) {
    const button = event.target.closest("[data-record-item]");
    if (!button) return;
    $a3eb3fffc17c3156$var$loadRecord(button.dataset.recordItem).then(()=>{
        window.dispatchEvent(new CustomEvent("workspace:navigate", {
            detail: {
                view: "records",
                tab: "editor"
            }
        }));
        return $a3eb3fffc17c3156$var$loadRecords();
    }).catch((error)=>$a3eb3fffc17c3156$var$showToast(error.message));
}
$a3eb3fffc17c3156$var$elements.newRecordButton.addEventListener("click", ()=>{
    $a3eb3fffc17c3156$var$resetForm();
});
$a3eb3fffc17c3156$var$elements.saveButton.addEventListener("click", ()=>{
    $a3eb3fffc17c3156$var$saveRecord().catch((error)=>$a3eb3fffc17c3156$var$showToast(error.message));
});
$a3eb3fffc17c3156$var$elements.publishButton.addEventListener("click", ()=>{
    $a3eb3fffc17c3156$var$saveRecord("published").catch((error)=>$a3eb3fffc17c3156$var$showToast(error.message));
});
$a3eb3fffc17c3156$var$elements.draftButton.addEventListener("click", ()=>{
    $a3eb3fffc17c3156$var$saveRecord("draft").catch((error)=>$a3eb3fffc17c3156$var$showToast(error.message));
});
$a3eb3fffc17c3156$var$elements.archiveButton.addEventListener("click", ()=>{
    $a3eb3fffc17c3156$var$saveRecord("archived").catch((error)=>$a3eb3fffc17c3156$var$showToast(error.message));
});
$a3eb3fffc17c3156$var$elements.deleteButton.addEventListener("click", ()=>{
    $a3eb3fffc17c3156$var$deleteActiveRecord().catch((error)=>$a3eb3fffc17c3156$var$showToast(error.message));
});
$a3eb3fffc17c3156$var$elements.uploadButton.addEventListener("click", ()=>{
    $a3eb3fffc17c3156$var$uploadCover().catch((error)=>$a3eb3fffc17c3156$var$showToast(error.message));
});
$a3eb3fffc17c3156$var$elements.importButton.addEventListener("click", ()=>{
    $a3eb3fffc17c3156$var$importBatch().catch((error)=>$a3eb3fffc17c3156$var$showToast(error.message));
});
$a3eb3fffc17c3156$var$elements.recordList.addEventListener("click", $a3eb3fffc17c3156$var$handleRecordSelection);
$a3eb3fffc17c3156$var$elements.overviewActivity?.addEventListener("click", $a3eb3fffc17c3156$var$handleRecordSelection);
let $a3eb3fffc17c3156$var$searchTimer = null;
$a3eb3fffc17c3156$var$elements.listSearch.addEventListener("input", (event)=>{
    clearTimeout($a3eb3fffc17c3156$var$searchTimer);
    $a3eb3fffc17c3156$var$searchTimer = window.setTimeout(()=>{
        $a3eb3fffc17c3156$var$state.listQuery = event.target.value.trim();
        $a3eb3fffc17c3156$var$loadRecords().catch((error)=>$a3eb3fffc17c3156$var$showToast(error.message));
    }, 180);
});
$a3eb3fffc17c3156$var$elements.statusFilter.addEventListener("change", (event)=>{
    $a3eb3fffc17c3156$var$state.listStatus = event.target.value;
    $a3eb3fffc17c3156$var$loadRecords().catch((error)=>$a3eb3fffc17c3156$var$showToast(error.message));
});
[
    $a3eb3fffc17c3156$var$elements.fieldName,
    $a3eb3fffc17c3156$var$elements.fieldCategory,
    $a3eb3fffc17c3156$var$elements.fieldCountry,
    $a3eb3fffc17c3156$var$elements.fieldRegion,
    $a3eb3fffc17c3156$var$elements.fieldSource,
    $a3eb3fffc17c3156$var$elements.fieldScore,
    $a3eb3fffc17c3156$var$elements.fieldTags,
    $a3eb3fffc17c3156$var$elements.fieldDescription,
    $a3eb3fffc17c3156$var$elements.fieldCoverImageUrl,
    $a3eb3fffc17c3156$var$elements.fieldExternalUrl
].forEach((input)=>{
    input.addEventListener("input", $a3eb3fffc17c3156$var$renderPreview);
});
$a3eb3fffc17c3156$var$editor.on("text-change", $a3eb3fffc17c3156$var$renderPreview);
window.addEventListener("beforeunload", (event)=>{
    if (!$a3eb3fffc17c3156$var$state.isDirty) return;
    event.preventDefault();
    event.returnValue = "";
});
$a3eb3fffc17c3156$var$resetForm();
$a3eb3fffc17c3156$var$loadRecords().catch((error)=>$a3eb3fffc17c3156$var$showToast(error.message));

})();
//# sourceMappingURL=index.9585b758.js.map
